
export const VIDEO_PROJECT_CARD_DELETE = 'VIDEO_PROJECT_CARD_DELETE';
export const VIDEO_PROJECT_CARD_UPDATE = 'VIDEO_PROJECT_CARD_UPDATE';
